
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import { returnInputFieldLength } from '../../../utils/commonFunctions';

type AppProps={
    showAddEditEmailerModal:boolean;
    isEdit:boolean;
    handleAddEmailer:()=>void;
    handleEmailerNameChange:(data:any)=>void;
    toggleAddEditEmailerModal:()=>void;
    emailerName:string;
    emailerNameError:string;
    subject:string;
    description:string;
    handleSubjectChange:(data:any)=>void;
    handleDescriptionChange:(data:any)=>void;
}

const AddEditEmailers = ({
    showAddEditEmailerModal,
    toggleAddEditEmailerModal,
    isEdit,
    emailerName,
    emailerNameError,
    handleAddEmailer,
    handleEmailerNameChange,
    subject,
    description,
    handleSubjectChange,
    handleDescriptionChange
}:AppProps) => {

    return (
        <Modal isOpen={showAddEditEmailerModal} toggle={toggleAddEditEmailerModal}>
            <ModalHeader className="pt-4 pl-4">
                {`${isEdit ? "Edit" : "Add"} Emailers`}
            </ModalHeader>
            <ModalBody className="pl-4 pr-4">
                <form>
                    <div className="form-group mt-3">
                        <div>
                            <label
                                htmlFor="foldername"
                                className={emailerName ? "active" : ""}
                            >
                                Enter Emailer Name <span className='color-red'>*</span>
                            </label>
                            <div className="d-flex flex-row position-relative">
                                <input
                                    type="text"
                                    className={`form-control ${!!emailerNameError ? "error-border" : null
                                        }`}
                                    name="text"
                                    value={emailerName}
                                    autoFocus
                                    onChange={(e) => handleEmailerNameChange(e)}
                                    maxLength={60}
                                    onKeyPress={(e: any) =>
                                        e.key === "Enter" ? handleAddEmailer() : null
                                    }
                                />
                            {!!emailerNameError && (
                                <small className="text-danger">{emailerNameError}</small>
                            )}
                        </div>
                        </div>
                        <span className="input-length">
                            {returnInputFieldLength(emailerName?.length, 60)}
                        </span>
                    </div>

                    <div className="form-group mt-3">
                <div>
                  <label htmlFor="status">Subject<span className='color-red'>*</span></label>
                  <input
                    type="text"
                    className={`form-control`}
                    name="text"
                    value={subject}
                    autoFocus
                    onChange={(e) => handleSubjectChange(e)}
                    maxLength={60}
                    onKeyPress={(e: any) =>
                      e.key === "Enter" ? handleAddEmailer() : null
                    }
                  />
                </div>
              </div>
              <div className="form-group mt-3">
                <div>
                  <label htmlFor="description">Description <span className='color-red'>*</span></label>
                  <textarea
                    className={`form-control`}
                    name="text"
                    value={description}
                    autoFocus
                    onChange={(e) => handleDescriptionChange(e)}
                    onKeyPress={(e: any) =>
                      e.key === "Enter" ? handleAddEmailer() : null
                    }
                  />
                </div>
              </div>
                </form>
            </ModalBody>
            <ModalFooter>
                <span className="pointer" onClick={toggleAddEditEmailerModal}>
                    Cancel
                </span>
                <Button
                    color="primary ml-3"
                    onClick={() => {
                        handleAddEmailer();
                        toggleAddEditEmailerModal();
                    }}
                    disabled={!emailerName?.trim().length || !description?.length || !subject 
                    }
                >
                    {isEdit ? "Update Emailer" : "Add Emailer"}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default AddEditEmailers

